import RecorderPage from './RecorderPage'

export default RecorderPage